import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Brain, LogOut } from "lucide-react";

export default function TopNav() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <header className="sticky top-0 z-30 bg-[var(--bg-page)] border-b-2 border-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
          <div className="w-10 h-10 rounded-xl bg-[var(--coral)] border-2 border-black shadow-[3px_3px_0_0_#1C1C1C] flex items-center justify-center">
            <Brain className="w-6 h-6 text-white" strokeWidth={2.5} />
          </div>
          <span className="font-extrabold text-xl tracking-tight">Knacky</span>
        </Link>
        <nav className="hidden md:flex items-center gap-6 text-sm font-semibold">
          <Link data-testid="nav-pricing" to="/pricing" className="hover:text-[var(--coral)]">Pricing</Link>
          <Link data-testid="nav-schools" to="/for-schools" className="hover:text-[var(--coral)]">For Schools</Link>
          <Link data-testid="nav-kids" to="/kids" className="hover:text-[var(--coral)]">Kid mode</Link>
          {user && <Link data-testid="nav-dashboard" to="/dashboard" className="hover:text-[var(--coral)]">Dashboard</Link>}
          {user && <Link data-testid="nav-practice" to="/practice" className="hover:text-[var(--coral)]">Practice</Link>}
          {user && <Link data-testid="nav-tutor" to="/tutor" className="hover:text-[var(--coral)]">AI Tutor</Link>}
          {user && <Link data-testid="nav-family" to="/family" className="hover:text-[var(--coral)]">Family</Link>}
        </nav>
        <div className="flex items-center gap-3">
          {user ? (
            <>
              <div className="hidden sm:flex items-center gap-2">
                {user.picture ? (
                  <img src={user.picture} alt="" className="w-8 h-8 rounded-full border-2 border-black" />
                ) : (
                  <div className="w-8 h-8 rounded-full bg-[var(--sun)] border-2 border-black flex items-center justify-center font-bold text-sm">
                    {user.name?.[0]?.toUpperCase()}
                  </div>
                )}
                <span className="text-sm font-semibold" data-testid="nav-user-name">{user.name}</span>
              </div>
              <button data-testid="nav-logout" onClick={async () => { await logout(); nav("/"); }} className="nb-btn nb-btn-secondary text-sm px-3 py-1.5">
                <LogOut className="w-4 h-4" /> Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login" className="nb-btn nb-btn-secondary text-sm px-3 py-1.5">Log in</Link>
              <Link to="/signup" data-testid="nav-signup" className="nb-btn text-sm px-3 py-1.5">Get started</Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
